/**
 * The match's first frame as an image (booking-contracts.md 15; speed.md 4):
 * match.thumbnailUrl, else playerVideoThumbnailUrl, a token URL served
 * immutable, so the service worker keeps it on disk until the record changes.
 * Null until the processor has written it; the caller then draws the video's
 * own frame as before.
 */
export function matchThumb(b: { match?: { thumbnailUrl?: string } | null; playerVideoThumbnailUrl?: string } | null | undefined): string | null {
  return b?.match?.thumbnailUrl || b?.playerVideoThumbnailUrl || null;
}

/** The service worker's image cache: Firebase Storage images, cache first, keyed by the full URL with its token. */
export function isStorageImage(url: string, destination: string): boolean {
  return destination === 'image' && /^https:\/\/(firebasestorage\.googleapis\.com|storage\.googleapis\.com)\//.test(url);
}
